import React, { useEffect, useContext } from "react";
import { BrowserRouter } from "react-router-dom";

import Router from "routes/Router";
import { AuthContext } from "stores/auth";

import "./styles/index.css";
import "@yaireo/tagify/dist/tagify.css";
import { useTranslation } from "react-i18next";

function App() {
  const authStore = useContext(AuthContext);
  const { i18n } = useTranslation();

  useEffect(() => {
    if (authStore.user?.preferred_language) {
      i18n.changeLanguage(authStore.user.preferred_language);
    }
  }, [authStore.user?.preferred_language]);

  return (
    <BrowserRouter>
      <Router />
    </BrowserRouter>
  );
}

export default App;

// Use this if app is under maintenance
// function App() {
//   return (
//     <main className="relative isolate min-h-full">
//       <img
//         alt=""
//         src="/assets/images/Landing.jpg"
//         className="absolute inset-0 -z-10 size-full object-cover object-top"
//       />
//       <div className="mx-auto max-w-7xl px-6 py-32 text-center sm:py-40 lg:px-8">
//         <h1 className="mt-4 text-5xl font-semibold tracking-tight text-balance text-white sm:text-7xl">
//           Temporarily Unavailable
//         </h1>
//         <p className="mt-6 text-lg font-medium text-pretty text-white/70 sm:text-xl/8">
//           We're making improvements to the platform and will be back online
//           shortly.
//           <br />
//           We appreciate your patience and look forward to serving you again
//           soon.
//         </p>
//       </div>
//     </main>
//   );
// }

// export default App;
